module.exports = __webpack_public_path__ + "static/goldm_3_1-a825557e22eb2501c8714ac4ef121f68.mp4";